// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"32":"740a1942768fd97d","262":"32cae0e516128d61"}[chunkId] + ".css";
};